// angular
import { Component } from '@angular/core';

// common

import { TreeStatus, SubscriberComponent, ISelfServMeta, TreeType } from '@aa/common';

// shared
import { QnaNavigationService } from './qna-navigation.service';
import { QnaStage } from '@aa/selfserv/shared';
import { delay } from 'rxjs/operators';

/**
 * See here for style info:
 * https://design-system.service.gov.uk/
 */
@Component({
  selector: 'aa-qna-page',
  templateUrl: './qna-page.component.html',
  styleUrls: ['./qna-page.component.scss'],
  // host: {'class': 'page'},
  providers: [QnaNavigationService],

})
export class QnaPageComponent extends SubscriberComponent {

  // expose enums to UI
  readonly TreeStatus = TreeStatus;
  readonly TreeType = TreeType;

  readonly meta: ISelfServMeta;
  private stage: QnaStage = QnaStage.None;
  public showBanner: boolean = false;
  public readonly hotjarEnabled: boolean = true;

  constructor(public readonly navigation: QnaNavigationService) {
    super();
    this.meta = this.navigation.meta;
    this.hotjarEnabled = !!navigation.hotjarId;

    // delay state to prevent view updated errors
    const stage$ = this.navigation.stage$.pipe(delay(0));
    super.subscribe(stage$, stage => this.setStage(stage));
  }

  private setStage(stage: QnaStage) {

    this.stage = stage;

    // hide banner on certain pages to conserve page types to maximise screen real estate
    switch (stage) {
      case QnaStage.Advice:
      case QnaStage.Questions:
        this.showBanner = false;
        break;
      default:
        this.showBanner = true;
        break;
    }
  }


  public get showBackButton(): boolean {
    return this.stage > QnaStage.Start;
  }

  public get showDisclaimer(): boolean {
    return this.stage === QnaStage.Advice;
  }
}
